import { IconChartHistogram, IconFileImport, IconLock, IconSettings, IconUsers } from '@tabler/icons-react';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { config } from '@/config/config';
import { AdminFirewall } from '@/modules/auth/components';
import { Version } from '@/modules/backend-version/components';
import { MenuItem } from '@/modules/layout';
import { LanguageSwitcher } from '@/modules/localizations';
import { SecurityAuditIndicator } from '@/modules/security-audit';
import { Link } from '@/modules/ui';
import { VaultsSection } from '@/modules/vaults';

import { SidebarLinks } from '../SidebarLinks';
import * as felaRules from './SidebarContent.rules';

export const SidebarContent = () => {
    const { css } = useFela();

    return (
        <div className={css(felaRules.container)}>
            <nav className={css(felaRules.nav)}>
                <MenuItem
                    icon={IconLock}
                    link={{
                        type: 'router',
                        to: config.routes.secrets,
                    }}
                >
                    <FormattedMessage id='menu.secrets' />
                </MenuItem>
                <VaultsSection />
                <MenuItem
                    icon={IconChartHistogram}
                    trailing={<SecurityAuditIndicator />}
                    additionalRoutesWithActiveClassName={[
                        config.routes.securityAuditAge,
                        config.routes.securityAuditLeaks,
                        config.routes.securityAuditLevel,
                    ]}
                    link={{
                        type: 'router',
                        to: config.routes.securityAudit,
                    }}
                >
                    <FormattedMessage id='menu.security-audit' />
                </MenuItem>
                <AdminFirewall loader={null}>
                    <MenuItem
                        icon={IconFileImport}
                        link={{
                            type: 'router',
                            to: config.routes.importExport,
                        }}
                    >
                        <FormattedMessage id='menu.import-export' />
                    </MenuItem>
                    <MenuItem
                        icon={IconUsers}
                        link={{
                            type: 'router',
                            to: config.routes.userAdministration,
                        }}
                    >
                        <FormattedMessage id='menu.user-administration' />
                    </MenuItem>
                    <MenuItem
                        icon={IconSettings}
                        link={{
                            type: 'router',
                            to: config.routes.settings,
                        }}
                    >
                        <FormattedMessage id='menu.settings' />
                    </MenuItem>
                </AdminFirewall>
            </nav>

            <div className={css(felaRules.bottomSection)}>
                <SidebarLinks />
                <LanguageSwitcher />
                <div className={css(felaRules.footer)}>
                    <div className={css(felaRules.footerLinks)}>
                        <Link type='router' to={config.routes.changelog} size='small' inheritColor customStyle={felaRules.footerLink}>
                            <FormattedMessage id='menu.changelog' />
                        </Link>
                        <Link type='native' href={config.links.roadmap} size='small' inheritColor customStyle={felaRules.footerLink}>
                            <FormattedMessage id='sidebar.links.roadmap' />
                        </Link>
                    </div>
                    <Version />
                </div>
            </div>
        </div>
    );
};
